<template>
  <div class="gameBlock">
    <div v-for="item in gameBlocks" class="lp_5_31" :key="item.id">
      <div class="lp_531">
        <div
          class="lp_5_312"
          :style="{
            backgroundImage: 'url(' + item.image + ')',
          }"
        ></div>
        <div class="lp_5_311">
          <div
            class="lp_5_3111"
            :style="{
              backgroundImage: 'url(' + item.icon + ')',
            }"
          ></div>
          <div class="lp_5_3112">
            <p class="lp_5_3113">{{ item.name }}</p>
            <p class="lp_5_3114">{{ item.description }}</p>
          </div>
          <router-link
            :to="'/gameDetailPage/' + item.id"
            exact
            class="lp_5_3115"
          ></router-link>
        </div>
      </div>
    </div>
    <div class="gb1" id="gb1">
      <p>{{ $t("noData") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "gameBlock",
  props: {
    gameBlocks: Array,
  },
  updated() {
    if (this.gameBlocks.length == 0) {
      document.getElementById("gb1").style.display = "block";
    } else {
      document.getElementById("gb1").style.display = "none";
    }
  },
  methods: {},
  data() {
    return {};
  },
};
</script>

<style>
.gameBlock {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: start;
  flex-flow: wrap;
}
.gb1 {
  text-align: center;
  display: flex;
  justify-content: center;
  line-height: 200px;
  width: 1200px;
  height: 200px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  display: none;
}
.lp_5_312 {
  width: 368px;
  height: 207px;
  margin: auto;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center center;
  transition: all 0.6s;
}
.lp_5_312:hover {
  background-size: 110%;
  /* background-size: 200% !important; */
}
.lp_5_31 {
  height: 327px;
  width: 400px;
  margin-top: 20px;
}
.lp_531 {
  height: 100%;
  width: 391px;
  background: url("../../assets/loop/loop14.png") no-repeat;
}
.lp_5_311 {
  display: flex;
  align-items: center;
  text-align: left;
  margin-top: 20px;
}
.lp_5_3111 {
  width: 56px;
  height: 56px;
  margin-left: 30px;
  /* background: url("../../assets/cp2.png") no-repeat center center; */
  border-radius: 12px;
  background-size: 100%;
}
.lp_5_3112 {
  height: 60px;
  width: 180px;
  padding-left: 20px;
}
.lp_5_3113 {
  height: 40px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.lp_5_3114 {
  width: 180px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lp_5_3115 {
  display: block;
  margin-left: 40px;
  width: 30px;
  height: 36px;
  background-image: url("../../assets/loop/loop13.png");
  cursor: pointer;
}
/* .lp_5_3115:hover {
  background-image: url("../assets/loop/loop13.png");
} */
</style>



// WEBPACK FOOTER //
// src/components/component/gameBlock.vue